export type AddressType = 'commercial' | 'residential';

export interface CustomerAddress {
  address1: string;
  address2: string;
  address_type: AddressType;
  city: string;
  company: string;
  country: string;
  country_code: string;
  customer_id: number;
  first_name: string;
  form_fields?: {
    name: string;
    value: string | number | string[];
  }[];
  id: number;
  last_name: string;
  phone: string;
  postal_code: string;
  state_or_province: string;
}

export enum CustomerAddressFormFields {
  Lat = 'Geo.Lat',
  Long = 'Geo.Long',
  GNAFPID = 'GNAFPID',
  ISRESTRICT = 'isRestrict',
}

export interface FirebaseReset {
  firebaseUid: string;
  email: string;
  firebaseAttributeId: number;
  bigCommerceId: number;
}
